import axios from 'axios';
import { LogTypes } from '../logs/LogType'
import logger from '../logs/log';
import {sha256} from 'js-sha256';
var response = [];
var errorData = '';
const httpClient = axios.create();
httpClient.defaults.timeout = parseInt(process.env.REACT_APP_SET_API_CALL_TIMEOUT_LIMIT);

class ApiCall {

async getMethodCallWithoutParam(url) {

    navigator.permissions.query({ name: 'geolocation' })
      .then(function (permissionStatus) {
        console.log('geolocation permission state is ', permissionStatus.state);

        permissionStatus.onchange = function () {
          console.log('geolocation permission state has changed to ', this.state);
        };
      });

    var long = '';
    var lat = '';
    navigator.geolocation.watchPosition(async function (position) {
      long = position.coords.longitude;
      lat = position.coords.latitude;
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
    });
 
    navigator.geolocation.getCurrentPosition(function (position) {
      console.log('position', position)
    });
    console.log('REACT_APP_Get_USER_PROFILE url', url, 'request');
    var device_info = {
      "device_info": {
        "device_os": window.navigator.vendor,
        "device_os_version": '9.0',
        "device_id": "8.3",
        "model_name": "Simulator",
        "imei": '',
        "time_stamp": "2018-05-02T16:29:17",
        "latitude": lat,
        "longitude": long,
        "ipaddress": "",
        "channel": ""
      }
    }
 
    let headers = {
      "device_info": JSON.stringify(device_info),
      "hashCode" : await this.generateHash('')
    }

    logger.infolog('200', url, LogTypes.REQUEST, ' ', '', 'Inside Api Calling');
    console.log('header_value_get', headers)
    return await httpClient.get(url, { headers :{"device_info": JSON.stringify(device_info),
    "hashCode" : await this.generateHash(''),} }, { headers })
      .then(async res => {
        console.log('device info', (window.navigator.vendor))
        console.log('device info', (window))
        console.log('device info header', res);
        response = await res.data;
        console.log('inside response', response)
        logger.infolog('200', url, LogTypes.RESPONSE, JSON.stringify(response), '', 'Response From Api Calling');
        if (response.response_code === 6503) {
            url = process.env.REACT_APP_REDIRECT_URL
           window.location.replace(url)
        }
        return response;
      }).catch(error => {
        console.log('error', error.response);
        errorData = 'error';
        logger.errorlog("url__"+url,'200', url, LogTypes.RESPONSE, ' ', 'Inside Error', error);
        console.log('inside errorr', error.response);
        if (!(error === undefined) && !(error.response === undefined) && !(error.response.data === undefined) && !(error.response.data.message === undefined)) {
          console.log('error', error.response.data.debugMessage);
          console.log('error', error.response.status);
          console.log('inside errorr', error);
          if (error.response.data.code !== undefined) {
            errorData = `${error.response.data.message}(Error:${error.response.data.code})`
          } else {
            errorData = `${error.response.data.message}`
          }
          console.log('inside errorr', errorData);
          if (error.response.status === 500) {
            if (error.response.data.code !== undefined) {
              errorData = `${error.response.data.message}(Error:${error.response.data.code})`
            } else {
              errorData = `${error.response.data.message}(Error:${error.response.status})`
            }
          }
          logger.errorlog('200', url, LogTypes.RESPONSE, ' ', 'Inside Error', error);

        } else {
          console.log('inside errorr ', error);
          logger.errorlog('200', url, LogTypes.RESPONSE, ' ', 'Inside Error', error);
          errorData = 'error';
        }
        return errorData;
      })
}

generateHash(messageBody){
  var privateKey=process.env.REACT_APP_CLIENT_ID;
  var hash = sha256.hmac.create(privateKey);
  hash.update(messageBody);
  var hexData=hash.hex();
  console.log('hexed data',hexData);
  var base64String= btoa(hexData);
  console.log(messageBody ,'---->hash Generated --->', base64String );
  return base64String;
}

async postMethodCall(url, request,user_type=false) {
    
    navigator.permissions.query({ name: 'geolocation' })
      .then(function (permissionStatus) {
        console.log('geolocation permission state is ', permissionStatus.state);

        permissionStatus.onchange = function () {
          console.log('geolocation permission state has changed to ', this.state);
        };
      });

    var long = '';
    var lat = '';
    navigator.geolocation.watchPosition(async function (position) {
      long = position.coords.longitude;
      lat = position.coords.latitude;
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
    });

    navigator.geolocation.getCurrentPosition(function (position) {
      console.log('position', position)
    });
    logger.infolog('200', url, LogTypes.REQUEST, JSON.stringify(request), '', 'Inside Api Calling');
    console.log('inside axios');
    var device_info = {
      "device_info": {
        "device_os": window.navigator.vendor,
        "device_os_version": '9.0',
        "device_id": "8.3",
        "model_name": "Simulator",
        "imei": '',
        "time_stamp": "2018-05-02T16:29:17",
        "latitude": lat,
        "longitude": long,
        "ipaddress": "",
        "channel": ""
      }
    }
    console.log('position', device_info)

    let headers = {
      "device_info": JSON.stringify(device_info),
      "hashCode" : await this.generateHash(JSON.stringify(request))
    }
    console.log('header_value_post', headers)
    console.log("headersNew", headers," TIMEOUT_LIMIT__"+process.env.REACT_APP_SET_API_CALL_TIMEOUT_LIMIT);
    return await httpClient.post(url, request, { headers: { "device_info": JSON.stringify(device_info),
    "hashCode" : await this.generateHash(JSON.stringify(request)), } }, { headers })

      .then(async res => {
        response = res.data;
        console.log('inside response', res.data);
        logger.infolog('200', url, LogTypes.RESPONSE, JSON.stringify(response), '', 'Response From Api Calling');
        if (response.response_code === 6503) {
          url = process.env.REACT_APP_REDIRECT_URL
          window.location.replace(url)
        }
        return response;
      }).catch(async (error) => {
        console.log('inside errorr', error.response);
        if (!(error === undefined) && !(error.response === undefined) && !(error.response.data === undefined) && !(error.response.data.message === undefined)) {
          console.log('error', error.response.data.debugMessage);
          console.log('error', error.response.status);
          console.log('inside errorr', error);
          if (error.response.data.code !== undefined) {
            errorData = `${error.response.data.message}(Error:${error.response.data.code})`
          } else {
            errorData = `${error.response.data.message}(Error:${error.response.status})`
          }
          console.log('inside errorr', errorData);
          if (error.response.status === 500) {
            if (error.response.data.code !== undefined) {
              errorData = `${error.response.data.message}(Error:${error.response.data.code})`
            } else {
              errorData = `${error.response.data.message}(Error:${error.response.status})`
            }
          }
          logger.errorlog('200', url, LogTypes.RESPONSE, JSON.stringify(request), 'Inside Error', errorData);

        } else {
          console.log('inside errorr ', error);
          errorData = 'error';
        }
        return errorData;
      })

  }

}

export default new ApiCall();